export enum LinkTypesEnum {
  a = 'a',
  nuxtLink = 'NuxtLink'
}

export type LinkTypes = LinkTypesEnum.a | LinkTypesEnum.nuxtLink
